var klaviyo = klaviyo || [];
klaviyo.init({
  account: "UjvSyZ",
  platform: "shopify",
});

klaviyo.enable("backinstock", {
  trigger: {
    product_page_text: "Bring It Back",
    product_page_class: "klaviyo-trigger",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false,
  },
  modal: {
    headline: "{product_name}",
    body_content:
      "Register to receive a notification if this item comes back in stock.",
    email_field_label: "Email",
    button_label: "Bring It Back",
    subscription_success_label: "Thanks! We'll let you know if it comes back.",
    footer_content: "",
    additional_styles:
      "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
    drop_background_color: "#fff",
    background_color: "#fff",
    text_color: "#100E0D",
    button_text_color: "#fff",
    button_background_color: "#000",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#fff",
    success_text_color: "#000",
  },
});
